/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_DescInputs */

const vi_camera_station_desc = /** @type {(inputs: Camera_Station_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera gắn ở đây hiện trên thẻ trạm để xem khi bật/tắt bơm. Một camera có thể gắn nhiều trạm và vẫn giữ vùng trồng của nó.`)
};

/**

* @param {Camera_Station_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_desc = /** @type {((inputs?: Camera_Station_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_desc(inputs)
});